import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { dialogs, i18next, utils } from '@yola/ws-sdk';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import CreateFolderDialog from '../components/create-folder-dialog';

const getCaptions = () => ({
  title: i18next.t('Create a folder'),
  folderNameLabel: i18next.t('Folder name'),
  submit: i18next.t('Submit'),
  cancel: i18next.t('Cancel'),
});

function CreateFolderDialogContainer({
  triggerId,
  onCancel = utils.noop,
  onSubmit = utils.noop,
  onDialogMainAction,
  onDialogCancel,
}) {
  const dispatch = useDispatch();
  const captions = getCaptions();

  const handleCancel = () => {
    onDialogCancel({
      dialogType: dialogTypes.CREATE_FOLDER_DIALOG,
      triggerId,
    });
    dispatch(dialogs.actions.show(dialogTypes.PAGE_MANAGER));
    onCancel();
  };

  const handleDialogSubmit = (folderName) => {
    onDialogMainAction({
      dialogType: dialogTypes.CREATE_FOLDER_DIALOG,
      triggerId,
      folderName,
    });
    onSubmit(folderName);
  };

  return (
    <CreateFolderDialog onSubmit={handleDialogSubmit} onCancel={handleCancel} captions={captions} />
  );
}

CreateFolderDialogContainer.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  triggerId: PropTypes.string.isRequired,
  onDialogMainAction: PropTypes.func.isRequired,
  onDialogCancel: PropTypes.func.isRequired,
};

export default CreateFolderDialogContainer;
